import React, { useState } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ZipDownload from '@mui/icons-material/Download';
import IconMinimiseGallerySidePanel from '../../assets/icons/IconMinimiseGallerySidePanel';
import IconExpansionGallerySidePanel from '../../assets/icons/IconExpansionGallerySidePanel';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/Store';

const GalleryActions = ({ onClose, onExpand, onZipDownload }: any) => {
  const [expanded, setExpanded] = useState(false);
  const isReadOnly = useSelector(
    (state: RootState) => state.contextId.isReadOnly
  );

  const handleExpand = () => {
    setExpanded(!expanded);
    onExpand(!expanded);
  };

  return (
    <Box
      display='flex'
      justifyContent='space-between'
      alignItems='center'
      mb={2}
    >
      <Box display='flex' alignItems='center' justifyContent='space-between'>
        <Typography
          variant='h6'
          sx={{
            color: '#343330',
            fontFamily: 'Montserrat',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: '600',
            lineHeight: 'normal',
            textTransform: 'capitalize',
            ml: 1,
          }}
        >
          Gallery
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <IconButton
          onClick={onZipDownload}
          sx={{
            '&.Mui-disabled': {
              cursor: 'not-allowed',
              pointerEvents: 'all !important', // Override pointer-events: none
            },
          }}
        >
          <ZipDownload />
        </IconButton>

        <IconButton onClick={handleExpand}>
          {expanded ? (
            <IconMinimiseGallerySidePanel />
          ) : (
            <IconExpansionGallerySidePanel />
          )}
        </IconButton>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

export default GalleryActions;
